const apiUrl = process.env.REACT_APP_API_URL;

export const createCheckoutSession = async (token, amount) => {
  const res = await fetch(`${apiUrl}/api/payments/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
     body: JSON.stringify({ amount }),
  });
  if (!res.ok) throw new Error('Failed to create checkout session');
  return await res.json();
};

export const getSheafBalance = async (token) => {
  const res = await fetch(`${apiUrl}/api/sheaf/balance`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to fetch Sheaf balance');
  return await res.json();
};

export const transferSheafToUser = async (token, recipientUsername, amount) => {
  const res = await fetch(`${apiUrl}/api/sheaf/transfer/user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ recipientUsername, amount }),
  });
  if (!res.ok) throw new Error('Failed to transfer Sheaf');
};

export const transferSheafToGroup = async (token, groupId, amount) => {
  const res = await fetch(`${apiUrl}/api/sheaf/transfer/group`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ groupId, amount }),
  });
  if (!res.ok) throw new Error('Failed to transfer Sheaf');
};

export const purchaseAssetWithSheaf = async (token, assetId) => {
  const res = await fetch(`${apiUrl}/api/sheaf/purchase-asset/${assetId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error('Failed to purchase asset with Sheaf');
};

export const confirmCheckoutSession = async (token, sessionId) => {
  const res = await fetch(`${apiUrl}/api/payments/confirm-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ sessionId }),
  });
  if (!res.ok) throw new Error('Failed to confirm checkout session');
};
